import React from 'react'

import { BLOCKS } from '@contentful/rich-text-types'
import clsx from 'clsx'

import Contentful from 'components/Contentful'
import YoutubeVideo from 'components/YoutubeVideo'
import { EventContext } from 'context/EventContext'

import styles from './EmbedVideo.module.scss'

const getCustomNodes = () => ({
  [BLOCKS.PARAGRAPH]: (_, children) => <span className={styles.footNote}>{children}</span>,
})

const EmbedVideo = ({ video }) => {
  return (
    <div className={clsx('EmbedVideo', styles.root)}>
      <EventContext
        value={{
          engagementComponent: 'resources_article',
        }}
      >
        <YoutubeVideo video={{ videoId: video?.youtubeId }} />
        <Contentful document={video.footnote?.json} getCustomNodes={getCustomNodes} />
      </EventContext>
    </div>
  )
}

export default EmbedVideo
